import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { patientNamespace } from "@/store/modules/patient";
import { navigationNamespace } from "@/store/modules/navigation";
import { Patient } from "@/store/modules/patient/types";

@Component({})
export default class BodyValues extends Vue {
  @Action("showPopup", navigationNamespace)
  showPopup!: Function;

  @Getter("config", patientNamespace)
  config!: any;

  @Prop(Object)
  data!: Patient;

  @Prop(Boolean)
  tall!: boolean;
}
